import { IManyToManyRelationship, IRelationship } from "@src/app/interfaces/entitydefinition";
import { IFormContext } from "../native/Form/interfaces/IFormContext";
import { Form } from "../native/Form/interfaces/form";
import { Grid } from "./Grid";
import { IColumn, IDataset } from "@talxis/client-libraries";
import { DatasetControl } from "./DatasetControl";

// @types/xrm don't expose getFetchXml https://docs.microsoft.com/en-us/power-apps/developer/model-driven-apps/clientapi/reference/grids/gridcontrol/getfetchxml
export interface IExtendedXrmGridControl extends Partial<Omit<Xrm.Controls.GridControl, 'getRelationship'>> {
    getFetchXml(): string;
    getViewColumns(): IColumn[]
    getGridType(): XrmGridType;
    getRelationship(): IXrmGridRelationship | undefined;
    //internal method that is not exposed by the interface
    getParentForm?: () => IFormContext;
    getGrid: () => Xrm.Controls.Grid;
    getDataset: () => IDataset;
}

interface IExtendedManyToManyRelationship extends IManyToManyRelationship {
    CurrentEntityIntersectAttribute: string;
    RelatedEntityIntersectAttribute: string;
}

export interface IXrmGridRelationship {
    entityName: string; // not present in Xrm getRelationship()
    recordId: string; // not present in Xrm getRelationship()
    attributeName: string;
    relationshipType: XrmRelationshipType;
    name: string;
    metadata: {
        oneToMany?: IRelationship
        many2Many?: IExtendedManyToManyRelationship
    }
}
export interface IXrmViewColumn {
    name: string,
    //internal type, unrelated to Xrm
    __displayName: string;
    relatedEntityName: string,
}

export interface IDatasetControlProps extends Omit<Form.Control, 'bindings'> {
    name: string;
    id: string;
    bindings: IGridBindings;
    //optional parameter override from url, has highest priority
    urlBindings?: IGridBindings;
}

export interface IInternalDatasetControlProps extends IDatasetControlProps {
    onGridLoaded: (grid: Grid, datasetControl: DatasetControl) => void;
    onGridLoadFailed: () => void;
    switchingView: boolean;
}

export interface IGridBindings {
    EnableFiltering?: Form.ParameterBinding;
    RelationshipName?: Form.ParameterBinding;
    RecordsPerPage?: Form.ParameterBinding;
    ViewIds?: Form.ParameterBinding;
    SearchPlaceholder?: Form.ParameterBinding;
    EnableQuickFind?: Form.ParameterBinding;
    //TODO: there might be other parameter for this 
    EnableViewPicker?: Form.ParameterBinding;
    EnableNavigation?: Form.ParameterBinding;
    EnableEditColumns?: Form.ParameterBinding;
    SelectableRows?: Form.ParameterBinding;
    TargetEntityType?: Form.ParameterBinding
    ViewId?: Form.ParameterBinding;
    IsViewPage?: Form.ParameterBinding;
    DisplayCommandBar?: Form.ParameterBinding;
    DisplayPaging?: Form.ParameterBinding;
    Height?: Form.ParameterBinding;
    DisableNewGrid?: Form.ParameterBinding;
    Columns?: Form.ParameterBinding;
    EnableUserQueries?: Form.ParameterBinding;
    EntityMetadata?: Form.ParameterBinding;
    HomePageGridClientApiRibbonButtonId?: Form.ParameterBinding;
    //represents the optional dataset parameter when using virtual grids
    [dataset: string]: any;
}

export interface ICdsOptions {
    displayQuickFind: boolean;
    displayIndex: boolean;
    displayCommandBar: boolean;
    displayViewSelector: boolean;
    displayPaging: boolean;
}

export interface IGridNativeStateValues {
    selectedRecordIds: string[];
    dataSource: string;
    searchValue: string;
    pageSize: number;
    pageNumber: number;
    columns: IColumn[],
    userFilter: ComponentFramework.PropertyHelper.DataSetApi.FilterExpression;
    sorting: ComponentFramework.PropertyHelper.DataSetApi.SortStatus[];
    linkedEntities: ComponentFramework.PropertyHelper.DataSetApi.LinkEntityExposedExpression[];
}

export enum XrmGridType {
    HomepageGrid = 1,
    Subgrid = 2
}

export enum XrmRelationshipType {
    OneToMany = 0,
    ManyToMany = 1
}